import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Button } from "../../ui";

export function SidebarSection({
  label,
  labelClassName,
  className,
  faIcon,
  imgSrc,
  onClick,
}: {
  label: string;
  labelClassName?: string;
  className?: string;
  faIcon?: IconProp;
  imgSrc?: string;
  onClick?: () => void;
}) {
  return (
    <Button
      className={`w-full border border-[#2E2E2E] bg-[#0F0F0F] rounded-xl p-4 flex justify-between items-center hover:bg-[#1f1f1f] ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        {faIcon && <FontAwesomeIcon icon={faIcon} />}
        {imgSrc && <img src={imgSrc} alt={label} className="w-6 h-6" />}

        <span className={labelClassName}>{label}</span>
      </div>
    </Button>
  );
}
